<div class="tile-progress bg-white text-left col-lg-12" style="padding: 0px;">
    <div>
      <div class="card-header">Framework Configuration</div>
      <div class="card-body">
        <table class="table">
          <tr style="display: flex; justify-content: space-around; padding-top: 30px;">
            <td style="font-size: 20px;">Payment Gateway</td>
            <td>
              <label class="switch">
                <input type="checkbox" [(ngModel)]="paymentGateway">
                <div class="slider">
                  <span class="on" style="color:white;font-size: medium;left:40%">PayuMoney</span><span class="off"
                    style="color:white;font-size: medium;left:55%">RazorPay</span>
                </div>
              </label>
            </td>
          </tr>
        </table>
      </div>
      <div class="card-footer text-center" style="margin-bottom: 10px;">
        <button class="btn btn-success" (click)="save()">Save</button>
      </div>
    </div>
</div>